<div [formGroup]="form" class="w-100">
  <ng-container *ngIf="street">
    <ng-container *ngIf="managePostal">
      <div class="row ml-0">
        <h2 *ngIf="showHeaders" style="color: #4c4c4c;">
          {{ titlePhysicalAddress.length > 0 ? titlePhysicalAddress :
          ('streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_STREET_ADDRESS' | translate)}}
        </h2>
        <a *ngIf="enableCopy" (click)="copy()" color="primary"
          style="margin-left:10px; margin-top:3px;">{{'language.copy' | translate}}</a>
      </div>
    </ng-container>
    <p>{{ 'management.requiredMessage' | translate }}</p>

    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/home.svg" style="margin-right: 1px !important; margin-bottom: 5px !important;"
              alt="home" class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_STREET_ADDRESS' | translate}}
          </mat-label>


          <input matInput formControlName="StreetAddress" [required]="this.isRequired">
          <!-- <mat-icon matPrefix aria-hidden="false" aria-label="home_outline">home_outline</mat-icon> -->



          <mat-error *ngIf="form.controls['StreetAddress'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/home.svg" style="margin-right: 1px !important; margin-bottom: 5px !important;"
              alt="home" class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_ADDRESS2' | translate}}
          </mat-label>
          <input matInput formControlName="StreetAddress2">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/public.svg"
              style="margin-right: 1px !important; margin-bottom: 5px !important;" alt="public"
              class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_PAIS_STREET' | translate}}
          </mat-label>
          <mat-select formControlName="Country" [required]="this.isRequired">
            <mat-option [value]="">{{'selection.selectOne' | translate}}</mat-option>
            <mat-option (click)="onCountryChange('City', 'State','MunicipioStreet', item.value)"
              *ngFor="let item of lookupService.countries" [value]="item.value">{{item.label}}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls['Country'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-6" *ngIf="this.form.controls.Country.value=='376'">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/public.svg"
              style="margin-right: 1px !important; margin-bottom: 5px !important;" alt="public"
              class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_MUNICIPIO_STREET' | translate}}
          </mat-label>
          <mat-select formControlName="MunicipioStreet" [required]="this.isRequired">
            <mat-option [value]="">{{'selection.selectOne' | translate}}</mat-option>
            <mat-option *ngFor="let item of lookupService.cities" [value]="item.value">{{item.label}}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls['MunicipioStreet'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row" *ngIf="this.form.controls.Country.value=='113'">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/public.svg"
              style="margin-right: 1px !important; margin-bottom: 5px !important;" alt="public"
              class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_ESTADO_STREET' | translate}}
          </mat-label>
          <mat-select formControlName="State" [required]="this.isRequired">
            <mat-option [value]="">{{'selection.selectOne' | translate}}</mat-option>
            <mat-option *ngFor="let item of lookupService.states" [value]="item.value">{{item.label}}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls['State'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/public.svg"
              style="margin-right: 1px !important; margin-bottom: 5px !important;" alt="public"
              class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_CIUDAD_STREET' | translate}}
          </mat-label>
          <input matInput formControlName="City" [required]="this.isRequired">
          <mat-error *ngIf="form.controls['City'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/markunread_mailbox.svg"
              style="margin-right: 1px !important; margin-bottom: 5px !important;" alt="markunread_mailbox"
              class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_POSTAL_CODE' | translate}}
          </mat-label>
          <input mask="00000" matInput formControlName="PostalCode" [required]="this.isRequired">
          <mat-error *ngIf="form.controls['PostalCode'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="ml-1 mb-3">
      <mat-checkbox formControlName="postalAsStreet" (change)="patchSameAsPhysical()" class=" m-b-20"
        *ngIf="managePostal==true">
        <mat-label>
          {{'streetPostalAdressFormComponent.GENERAL_INFO_POSTAL_AS_STREET' | translate}}
        </mat-label>
      </mat-checkbox>
    </div>

  </ng-container>
  <ng-container *ngIf="this.form.controls.postalAsStreet.value == false && managePostal==true">

    <ng-container *ngIf="street">
      <div class="row ml-1">
        <h2 style="color: #4c4c4c;">{{ titlePostalAddress.length > 0 ? titlePostalAddress :
          ('streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_POSTAL_ADDRESS' |
          translate)}}</h2>
        <a *ngIf="enableCopy" (click)="copy()" color="primary"
          style="margin-left:10px; margin-top:3px;">{{'language.copy' | translate}}</a>
      </div>
    </ng-container>

    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/home.svg" style="margin-right: 1px !important; margin-bottom: 5px !important;"
              alt="home" class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_POSTAL_ADDRESS' | translate}}
          </mat-label>
          <input matInput formControlName="PostalAddress"
            [required]="this.form.controls.postalAsStreet.value==false && this.isRequired">
          <mat-error *ngIf="form.controls['PostalAddress'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/home.svg" style="margin-right: 1px !important; margin-bottom: 5px !important;"
              alt="home" class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_POSTAL_ADDRESS2' | translate}}
          </mat-label>
          <input matInput formControlName="PostalAddress2">
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/public.svg"
              style="margin-right: 1px !important; margin-bottom: 5px !important;" alt="public"
              class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_PAIS_STREET' | translate}}
          </mat-label>
          <mat-select formControlName="CountryPostal"
            [required]="this.form.controls.postalAsStreet.value==false && this.isRequired">
            <mat-option [value]="">{{'selection.selectOne' | translate}}</mat-option>
            <mat-option (click)="onCountryChange('CityPostal', 'StatePostal','MunicipioPostal', item.value)"
              *ngFor="let item of lookupService.countries" [value]="item.value">{{item.label}}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls['CountryPostal'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-4" *ngIf="this.form.controls.CountryPostal.value=='376'">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/public.svg"
              style="margin-right: 1px !important; margin-bottom: 5px !important;" alt="public"
              class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_MUNICIPIO_POSTAL' | translate}}
          </mat-label>
          <mat-select formControlName="MunicipioPostal">
            <mat-option [value]="">{{'selection.selectOne' | translate}}</mat-option>
            <mat-option *ngFor="let muni of lookupService.cities" [value]="muni.value">{{muni.label}}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls['MunicipioPostal'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>

      </div>
    </div>

    <div class="row" *ngIf="this.form.controls.CountryPostal.value=='113'">
      <div class="col-sm-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/public.svg"
              style="margin-right: 1px !important; margin-bottom: 5px !important;" alt="public"
              class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_ESTADO_STREET' | translate}}
          </mat-label>
          <mat-select formControlName="StatePostal">
            <mat-option [value]="">{{'selection.selectOne' | translate}}</mat-option>
            <mat-option *ngFor="let item of lookupService.states" [value]="item.value">{{item.label}}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls['StatePostal'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-sm-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/public.svg"
              style="margin-right: 1px !important; margin-bottom: 5px !important;" alt="public"
              class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_CIUDAD_STREET' | translate}}
          </mat-label>
          <input matInput formControlName="CityPostal">
          <mat-error *ngIf="form.controls['CityPostal'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label class="t-w-w-s">
            <img src="assets/images/ideal/markunread_mailbox.svg"
              style="margin-right: 1px !important; margin-bottom: 5px !important;" alt="markunread_mailbox"
              class="input-icon-aligned">
            {{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_P_POSTAL_CODE' | translate}}
          </mat-label>
          <input mask="00000" matInput formControlName="PPostalCode"
            [required]="this.form.controls.postalAsStreet.value==false && this.isRequired">
          <mat-error *ngIf="form.controls['PPostalCode'].hasError('required')">
            {{'GLOBAL.REQUIRED_FIELD' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </ng-container>
</div>